import type { Response } from '~/types/api/v2'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export type Usage = Record<'usage-signature' | 'usage-document', {
  total: number
  used: number
}>

export const useFetchUsages = () => {
  const { get } = useFetchWithDefaults()
  const url = '/v2/usages'

  return {
    getAll: ({ workspaceId }: WorkspaceIdentifier) => get<Response<Usage>>({ url, workspaceId }),
  }
}
